var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHatButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 20.455,
    viewBox: "0 0 25 20.455",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "school_FILL0_wght400_GRAD0_opsz48",
    d: "M14.472,26.455,6.233,21.937V15.119L2,12.818,14.472,6,27,12.818v9.006H25.3V13.812L22.71,15.119v6.818Zm0-8.75,8.949-4.886-8.949-4.8-8.892,4.8Zm0,6.818,6.534-3.608V16.142l-6.534,3.494L7.938,16.085v4.83ZM14.5,17.7ZM14.472,19.807ZM14.472,19.807Z",
    transform: "translate(-2 -6)",
    fill: "#00aeef"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHatButton);
export default __webpack_public_path__ + "static/media/hatButton.f89d8aed93b0ba5baa85f1cc56365973.svg";
export { ForwardRef as ReactComponent };